namespace Matrix.Data {
    export interface PartyRolePartyRow {
        PartyCode?: string;
        PartyName?: string;
        RoleCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace PartyRolePartyRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'PartyCode';
        export const localTextPrefix = 'Data.PartyRoleParty';
        export const lookupKey = 'DataAdmin.PartyRoleParty';

        export function getLookup(): Q.Lookup<PartyRolePartyRow> {
            return Q.getLookup<PartyRolePartyRow>('DataAdmin.PartyRoleParty');
        }
        export const deletePermission = 'DataAdmin:PartyRoleParty';
        export const insertPermission = 'DataAdmin:PartyRoleParty';
        export const readPermission = 'Read:PartyRoleParty';
        export const updatePermission = 'DataAdmin:PartyRoleParty';

        export declare const enum Fields {
            PartyCode = "PartyCode",
            PartyName = "PartyName",
            RoleCode = "RoleCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
